import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../../molecules/Header';
import Error from '../../molecules/Error';


class ErrorPage extends Component {
  render() {
    const errorCode = this.props.location.pathname.substr(14);
    return [
      <Header />,
      <Error errorCode={errorCode} />,
    ];
  }
}

ErrorPage.propTypes = {
  location: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default ErrorPage;



// WEBPACK FOOTER //
// src/components/pages/ErrorPage/index.jsx